import { Modal, styled } from "@mui/material";
import { grey } from "../../../common/Theme/theme";

const UNLOCK_CONTACT_MODAL_PREFIX = "unlockContactModal";

export const unlockContactModalClasses = {
    root: `${UNLOCK_CONTACT_MODAL_PREFIX}-root`,
    paper: `${UNLOCK_CONTACT_MODAL_PREFIX}-paper`,
    acceptButton: `${UNLOCK_CONTACT_MODAL_PREFIX}-acceptButton`,
    description: `${UNLOCK_CONTACT_MODAL_PREFIX}-description`,
    modalTitle: `${UNLOCK_CONTACT_MODAL_PREFIX}-modalTitle`,
    price: `${UNLOCK_CONTACT_MODAL_PREFIX}-price`,
    icons: `${UNLOCK_CONTACT_MODAL_PREFIX}-icons`,
};
export const StyledUnlockContactModal = styled(Modal)(({ theme }) => ({
    [`&.${unlockContactModalClasses.root}`]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
    },
    [`& .${unlockContactModalClasses.paper}`]: {
        padding: "20px",
        width: "600px",
        display: "flex",
        "flex-direction": "column",
        "justify-content": "space-between",
        [theme.breakpoints.only("xs")]: {
            width: "320px",
            margin: "auto",
        },
    },
    [`& .${unlockContactModalClasses.acceptButton}`]: {
        width: "200px",
        height: "40px",
        borderRadius: "100px",
        color: "white",
    },
    [`& .${unlockContactModalClasses.description}`]: {
        color: grey,
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        [theme.breakpoints.only("xs")]: {
            fontSize: "14px",
        },
    },
    [`& .${unlockContactModalClasses.modalTitle}`]: {
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        paddingRight: "290px",
        [theme.breakpoints.only("xs")]: {
            fontSize: "14px",
            paddingRight: "50px",
        },
    },
    [`& .${unlockContactModalClasses.price}`]: {
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "16px",
    },
    [`& .${unlockContactModalClasses.icons}`]: {
        [theme.breakpoints.only("xs")]: {
            width: "15px",
        },
    },
}));
